"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BpmnTags = exports.Model = void 0;
/* eslint-disable @typescript-eslint/no-unused-vars */
const activities = require("./Activities/index");
const base = require("./Base/index");
const bpmnTags = require("./BpmnComponentTags");
const events = require("./Events/index");
const gateways = require("./Gateways/index");
const globalElements = require("./GlobalElements/index");
const processElements = require("./ProcessElements/index");
const collaboration = require("./Collaboration");
const definition = require("./Definitions");
const participant = require("./Participant");
const process = require("./Process");
const xmlns = require("./XMLNS");
var Model;
(function (Model) {
    Model.Activities = activities;
    Model.Base = base;
    Model.Collaboration = collaboration.Collaboration;
    Model.Definitions = definition.Definitions;
    Model.Events = events;
    Model.Gateways = gateways;
    Model.GlobalElements = globalElements;
    Model.Participant = participant.Participant;
    Model.Process = process.Process;
    Model.ProcessElements = processElements;
    Model.Xmlns = xmlns.Xmlns;
})(Model = exports.Model || (exports.Model = {}));
var BpmnTags;
(function (BpmnTags) {
    BpmnTags.CamundaProperty = bpmnTags.CamundaProperty;
    BpmnTags.CommonElement = bpmnTags.CommonElement;
    BpmnTags.GatewayElement = bpmnTags.GatewayElement;
    BpmnTags.EventElement = bpmnTags.EventElement;
    BpmnTags.TaskElement = bpmnTags.TaskElement;
    BpmnTags.FlowElementProperty = bpmnTags.FlowElementProperty;
    BpmnTags.Lane = bpmnTags.Lane;
    BpmnTags.LaneProperty = bpmnTags.LaneProperty;
    BpmnTags.XmlnsProperty = bpmnTags.XmlnsProperty;
})(BpmnTags = exports.BpmnTags || (exports.BpmnTags = {}));
__exportStar(require("./Constants"), exports);
__exportStar(require("./ProcessList"), exports);
//# sourceMappingURL=index.js.map